module.exports = __webpack_public_path__ + "media/icon_transaction/hedgehog_4-1517e5b3.png";